export default [

     {
          path: '/certifiate-templete',
          name: 'CertifiateTemplete',
          component: () => import("@/views/Page/CertifiateTemplete/CertifiateTemplete.vue"),
           meta: {
               title: 'CertifiateTemplete',
          },
     }
];